import type {
  OperationalSearchIndexRow,
  ParsedAttributeQuery,
  SmartSearchFeatureHit,
} from '../types'

import { matchesAttributeHaystack } from './matchAttributeHaystack'
import { operationalRowToFeatureHit } from './operationalRowToFeatureHit'
import { hasPositiveTerms } from './parseAttributeQuery'

export const SMART_SEARCH_MAX_RESULTS = 300

export function filterSearchIndex(
  rows: OperationalSearchIndexRow[],
  parsed: ParsedAttributeQuery,
): SmartSearchFeatureHit[] {
  if (!hasPositiveTerms(parsed)) return []

  const hits: SmartSearchFeatureHit[] = []

  for (let i = 0; i < rows.length; i += 1) {
    const row = rows[i]
    if (!matchesAttributeHaystack(row.haystack, parsed)) continue

    hits.push(operationalRowToFeatureHit(row, `${row.layerId}-${i}`))

    if (hits.length >= SMART_SEARCH_MAX_RESULTS) break
  }

  return hits
}
